import { Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react18-input-otp";
import sha256 from "sha256";
import Header from "../../common/Header";
import { userLoginWithEmail } from "../../services/authServices";
import style from "./loginOTP.module.css";

export default function LoginOTP({ close, email }) {
  const [enterOTP, setEnterOTP] = useState("");
  const [enterOTP_store, setEnterOTP_Store] = useState("");
  const navigate = useNavigate();

  const handleChangeOtp = (otp, event) => {
    setEnterOTP(otp);
    setEnterOTP_Store(otp);
    if(otp.length === 6){
      handleSubmitOTP(otp)
    }
  };

  const handleSubmitOTP = (otp) => {
    // postUserlogin();
    callUserLoginAPI(otp);
  };

  const callUserLoginAPI = async (otp) => {
    try {
      const object = {
        // country_code: "+" + mobileNumber?.country_code,
        // secret_access_key: sha256(enterOTP_store),
        secret_access_key: sha256(otp),
        email: email,
        // mobile_no: mobileNumber?.mobile_no,
      };

      const request = await userLoginWithEmail(object);
      const response = await request.data;

      if (response.status == 1) {
        JSON.stringify(localStorage.setItem("login", true));
        localStorage.setItem("userId", response?.data?._id);
        localStorage.setItem("session_id", response?.data?.session_id);
        navigate("/");
      }else{
        setEnterOTP("")
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box className={style.container}>
      <Header header="Login" navigateRoute={close} bgColor="transparent" />

      <Box className={style.hero_container}>
        {/* <img src={heroImg} /> */}
        <img
          src={process.env.PUBLIC_URL + "/assets/images/sky-sunset 1.png"}
          alt="bg_image"
        />
      </Box>

      <Box
        style={{
          position: "absolute",
          width: "100%",
          padding: "1rem",
          bottom: "0%",
        }}
      >
        <Box>
          <h4 className={style.login_des}>
            Enter your 6 digit Passcode to access the app
          </h4>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <OtpInput
              value={enterOTP}
              // value={(enterOTP ?? '').split("")?.map(txt => "*")}
              onChange={handleChangeOtp}
              numInputs={6}
              isInputNum={true}
              isSuccessed={false}
              errorStyle="error"
              successStyle="success"
              isInputSecure
              inputProps={{
                type: "password",
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              shouldAutoFocus
              onSubmit={handleSubmitOTP}
              inputStyle={{
                width: "100%",
                maxWidth: "50px",
                marginLeft: "0.5rem",
                height: "4.6875rem",
                border: "1px solid transparent",
                borderRadius: "8px",
                fontSize: "25px",
                // fontSize: " 1.0625",
                color: "#000",
                fontWeight: "400",
                caretColor: "black",
                outline: "none",
                boxShadow: "0px 2px 2px 0px #222222",
              }}
              focusStyle={{
                border: "2px solid black",
              }}
            />
          </Box>
        </Box>
        <br />
        <br />
        {/* <Box>
          <button
            className={style.confirmButton}
            disabled={enterOTP?.length !== 6}
            style={{
              ...(enterOTP?.length == 6
                ? { background: "#7F3F97", color: "white" }
                : {}),
              letterSpacing: "1px",
            }}
            onClick={() => {
              callUserLoginAPI();
            }}
          >
            Login
          </button>
        </Box> */}
      </Box>
    </Box>
  );
}
